import styled from 'styled-components'

export const SFileInput = styled.input `
    opacity:0
    position:absolute;
    bottom:-50px;

`